/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem5Dialog extends Serenity.Extensions.GridEditorDialog<PsAdvPromoItem5Row> {

        // static from: string;
        protected getFormKey() { return PsAdvPromoItem5Form.formKey; }
        // protected getIdProperty() { return PsAdvPromoItem5Row.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoItem5Row.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoItem5Row.nameProperty; }
        protected getService() { return PsAdvPromoItem5Service.baseUrl; }
        // protected getDeletePermission() { return PsAdvPromoItem5Row.deletePermission; }
        // protected getInsertPermission() { return PsAdvPromoItem5Row.insertPermission; }
        // protected getUpdatePermission() { return PsAdvPromoItem5Row.updatePermission; }

        protected form = new PsAdvPromoItem5Form(this.idPrefix);

        private pass: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        constructor() {
            super();


            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 1
                    this.form.StyleCode.value = null
                    this.form.CatCode.value = null
                    this.form.SubCat1Code.value = null
                    this.form.SubCat2Code.value = null
                    this.form.BrandCode.value = null
                    this.form.SupplCode.value = null
                }
                if (Fg = null) {
                    // this.form.ListFg.value = 0
                }
            });
            this.form.StyleCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.StyleCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });
            this.form.CatCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.CatCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });
            this.form.SubCat1Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat1Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });
            this.form.SubCat2Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat2Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });
            this.form.SupplCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.SupplCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });
            this.form.BrandCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.BrandCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 0
                    this.form.PluCode.value = null
                }

            });

            this.form.PmExtCode.changeSelect2(e => {
                let ex = Q.toId(this.form.PmExtCode.value)
                let gp = Q.toId(this.form.PmGroupId.value)
                this.form.PmId.value = ex + gp;
            });

            this.form.ListFg.changeSelect2(e => {
                this.ListFgCheck();
            });

        }




        // private get AssortFg1() {
        //     return this.form.AssortFg.value = "1";
        // }

        // private get AssortFg2() {
        //     return this.form.AssortFg.value = "2";
        // }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            let newitem: Serenity.ToolButton =
            {
                title: "เพิ่ม&ใช้ข้อมูลเดิม",
                hint: "add and new [alt+s]",
                separator: false,
                cssClass: "button-addandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: () => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                        Q.confirm('ยืนยันการเพิ่ม'
                            + "\r\n" + "โดยคงค่าข้อมูลเดิม "
                            , () => {

                                // e.preventDefault();
                                this.saveAndNew();
                                // this.FreeLpFgcheck();
                                this.ListFgCheck();

                            });
                    }
                }
            };
            buttons.push(newitem);
            let newitem2: Serenity.ToolButton =
            {
                title: "เพิ่ม&สร้างใหม่",
                hint: "add and clear [alt+a]",
                separator: false,
                cssClass: "button-addandclear",
                icon: "fa fa-save",
                hotkey: 'alt+a',
                onClick: (e) => {

                    var s = this.Checkbeforsave();

                    if (s) {

                    }

                    else {

                        e.preventDefault();
                        Q.confirm('ยืนยันการเพิ่ม และสร้างรายการใหม่ทั้งหมด'
                            + "\r\n" + "โดย ล้างรายการที่ป้อนทั้งหมด", () => {

                                this.saveAndclear();
                                // this.FreeLpFgcheck();
                                this.ListFgCheck();
                                // this.dialogClose();
                            });
                    }
                }
            };
            buttons.push(newitem2);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );
            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            // if (f.PmStepNo == null) {
            //     var pmstep = f.PmStepNo.value;
            // }else{
            //     var pmstep = f.PmStepNo.value+1;
            // }
            this.save((response) => {
                let ent: PsAdvPromoItem5Row = {
                    PmGroupId: f.PmGroupId.value,
                    PmId: f.PmId.value,
                    PmType: f.PmType.value,
                    PmExtCode: f.PmExtCode.value,
                    // PmStepNo: pmstep,
                    PmDesc: f.PmDesc.value,

                    // ItemType: Number(f.ItemType.value),
                    AssortFg: Number(f.AssortFg.value),
                    DiscPc1: f.DiscPc1.value,
                    DiscPc2: f.DiscPc2.value,
                    // FreeLpFg: Number(f.FreeLpFg.value),
                    DiscPc3: f.DiscPc3.value,
                    DiscPc4: f.DiscPc4.value,

                    ListFg: Number(f.ListFg.value),
                    PluCode: f.PluCode.value,
                    StyleCode: f.StyleCode.value,
                    BrandCode: f.BrandCode.value,
                    CatCode: f.CatCode.value,
                    SubCat1Code: f.SubCat1Code.value,
                    SubCat2Code: f.SubCat2Code.value,
                    SupplCode: f.SupplCode.value
                };
                this.loadEntity(ent);
            });

        }
        private saveAndclear() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PsAdvPromoItem5Row = {
                    PmGroupId: e.PmGroupId,
                    PmType: e.PmType

                };
                this.loadEntity(ent);
            });

        }



        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew()) {
                this.form.PmGroupId.value = this.pass                
            }
            
            else {
                // this.FreeLpFgcheck();
                this.ListFgCheck();
            }

        }

        private Checkbeforsave() {

             if(this.form.DiscPc1.value== null && this.form.DiscPc2.value != null 
                || 
                this.form.DiscPc2.value== null && this.form.DiscPc3.value != null
                ||
                this.form.DiscPc1.value== null && this.form.DiscPc3.value != null
                ||
                this.form.DiscPc1.value== null && this.form.DiscPc4.value != null
                ||
                this.form.DiscPc2.value== null && this.form.DiscPc4.value != null
                ||
                this.form.DiscPc3.value== null && this.form.DiscPc4.value != null
                ){
                    Q.warning("ลำดับขั้นก่อนหน้า ไม่ถูกใส่ค่า" +"\r\n" + "(หากไม่ได้ต้องการใช้ส่วนลด ในรายการก่อนหน้ากรุณาใส่ 0)")
                        return true               
               
                }
                else{

            if (this.form.ListFg.value == "1" && this.form.PluCode.value == "") {
                Q.warning("โปรด เลือกสินค้า")
                return true
            }
            else if (this.form.ListFg.value == "2" &&
                this.form.StyleCode.value == "" && this.form.CatCode.value == ""
                && this.form.SubCat1Code.value == "" && this.form.SubCat2Code.value == ""
                && this.form.BrandCode.value == "" && this.form.SupplCode.value == "") {
                Q.warning("โปรด ระบุเกณฑ์สินค้า")
                return true
            }
            else {
               
                return false 
            }
            }


        }
        private ListFgCheck() {
            let ex = Q.toId(this.form.ListFg.value)
            if (ex == 2) {
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, false);
                this.form.PluCode.value = null
            }
            if (ex == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.PluCode, false);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
            }
            if (ex == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
                this.form.PluCode.value = null
            }
        }

    }
}